module.exports = __webpack_public_path__ + "img/icon_map_marker.e79d0c2d.svg";